import React from 'react';
import {
  MarketingLayout,
  Section,
  Hero,
  CallToAction,
} from '@byscott-io/corebyscott';

export default function AboutPage() {
  return (
    <MarketingLayout>
      <Hero
        headline="About LifeSkillsPath"
        subheadline="We're building tools to help families raise capable, confident young adults."
        background="gray"
        layout="centered"
      />

      <Section background="white">
        <div className="mx-auto max-w-3xl prose prose-lg prose-indigo">
          <h2>Our Mission</h2>
          <p>
            LifeSkillsPath was created with a simple belief: education is more than academics.
            While test scores and grade levels matter, so does knowing how to cook a meal,
            manage money, and navigate the real world.
          </p>
          <p>
            We built LifeSkillsPath to help homeschool families, co-ops, and schools track the
            whole picture of student development - from reading and math to life skills and
            independence. Our at-home assessments let parents and educators understand where
            students are today and celebrate their growth over time.
          </p>

          <h2>Why We Built This</h2>
          <p>
            Too many assessment tools are designed for institutions, not families. They're
            complicated, expensive, and often require proctored testing environments. We
            wanted something different.
          </p>
          <p>
            LifeSkillsPath assessments are designed to be administered at home by parents and
            educators who know their students best. They're practical, affordable, and focused
            on growth rather than just measurement.
          </p>

          <h2>Our Values</h2>
          <ul>
            <li>
              <strong>Whole-Child Development</strong> - Academics matter, but so do life skills,
              character, and practical abilities. We track it all.
            </li>
            <li>
              <strong>Family-First Design</strong> - Every feature is designed with homeschool
              families in mind. Simple to use, easy to understand.
            </li>
            <li>
              <strong>Progress Over Perfection</strong> - We celebrate growth. Our assessments
              help you see improvement year over year, not just a single snapshot.
            </li>
            <li>
              <strong>Privacy & Trust</strong> - Your family's data is yours. We never sell or
              share your information with anyone.
            </li>
          </ul>

          <h2>Part of IdeasByScott</h2>
          <p>
            LifeSkillsPath is developed by <a href="https://byscott.io" target="_blank" rel="noopener noreferrer">IdeasByScott</a>,
            a software development company focused on building practical tools for real-world problems.
          </p>
        </div>
      </Section>

      <CallToAction
        headline="Ready to get started?"
        description="Try LifeSkillsPath free for 14 days. No credit card required."
        primaryCta={{ label: 'Start Free Trial', href: '/register' }}
        secondaryCta={{ label: 'Contact Us', href: '/contact' }}
        background="primary"
      />
    </MarketingLayout>
  );
}
